import React, { memo, useState } from 'react';
import { Blok } from '../../interfaces/Blok.interface';
import { Theme } from '../../interfaces/enums/Theme.enum';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';
import Modal from '../Modal/Modal';
import YoutubeVideo from '../YoutubeVideo/YoutubeVideo';
import VideoThumbnail from './VideoThumbnail';
import { useInView } from 'react-intersection-observer';
import { StoryblokAsset } from '../../interfaces/StoryblokAsset.interface';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';

interface VideoBlokProps {
  video_thumbnail: StoryblokAsset;
  video_id: string;
  structured_data: Blok[];
  className: string;
}
interface VideoProps {
  blok: VideoBlokProps;
}

const Video: React.FC<VideoProps> = ({ blok }) => {
  const [onVideoPlay, setOnVideoPlay] = useState<boolean>(false);
  const { video_thumbnail, video_id, structured_data = [], className } = blok;
  const { ref, inView } = useInView();

  return (
    <div ref={ref} {...storyblokEditable(blok)} className="h-full w-full">
      {structured_data?.map((structuredDataBlok: Blok) => (
        <StoryblokComponent
          blok={{
            ...structuredDataBlok,
            video_id: video_id,
            video_thumbnail: video_thumbnail,
          }}
          key={structuredDataBlok._uid}
        />
      ))}
      <VideoThumbnail
        video_thumbnail={video_thumbnail}
        toggleVideo={setOnVideoPlay}
      />
      {onVideoPlay && (
        <Modal toggleModal={onVideoPlay} onClose={setOnVideoPlay}>
          <div className="w-full h-full">
            <YoutubeVideo
              videoIsPlaying={onVideoPlay}
              loop={false}
              inView={true} // Always true when playing
              video_id={video_id}
              className={className}
            />
          </div>
        </Modal>
      )}
    </div>
  );
};

export default memo(withBlokWrapper(Video, Theme.DARK, undefined, 'w-full'));
